<template>
  <ul class="wizard-nav">
    <li v-for="(step, index) in component.steps" :class="component.currentStep(index)" :key="index">
      <span class="circle"
        :class="[index == 3 ? 'last' : '']">{{ component.currentStep(index) == 'pass' || index == 3 ? '&#x2713;' : index + 1 }}</span>
      <p>{{ step.title }}</p>
    </li>
  </ul>
</template>
<script setup lang="ts">
import component from "./navigation.component";
const step = defineProps({ name: String });
component.currentStepName = String(step.name);
</script>